<template>
  <div
    class="page-header header-filter jipvio-login"
    style="background-color: #ffffff;"
  >
    <div class="page-header-image" style=""></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto ">
          <card type="login" plain>
            <div slot="header" class="logo-container jipvio-login-color">
              <h2>로그인</h2>
            </div>

            <fg-input
              v-model="loginInfo.email"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons users_circle-08"
              placeholder="이메일 주소를 입력하세요"
              @keyup.enter.native="login()"
            ></fg-input>

            <fg-input
              type="password"
              v-model="loginInfo.password"
              class="no-border input-lg"
              addon-left-icon="now-ui-icons text_caps-small"
              placeholder="비밀번호를 입력하세요"
              @keyup.enter.native="login()"
            ></fg-input>
            <div>
              <div class="pull-right">
                <!-- <el-checkbox
                  v-model="loginInfo.checked"
                  label="로그인 유지"
                ></el-checkbox> -->
                <!--<a class="link footer-link"
                    ><i class="far fa-square"></i> 로그인 유지</a
                  >-->
              </div>
              <!-- <div class="pull-right ">
                <h6>
                  <a class="link footer-link" href="#">ID/비밀번호 찾기</a>
                </h6>
              </div> -->
            </div>

            <template slot="raw-content">
              <div class="card-footer text-center">
                <a
                  @click="login()"
                  class="btn btn-primary btn-round btn-lg btn-block"
                  >로그인</a
                >
              </div>
              <!-- <div style="border-bottom: 2px solid #2d2d36; height:30px;">
                <div>
                  <div class="pull-left ">
                    <h6>
                       <a class="link footer-link" href="/signup"
                        >회원가입 바로가기</a
                      >
                    </h6>
                  </div>
                  <div class="pull-right ">
                    <h6>
                      <a class="link footer-link" href="#"
                        >도움이 필요하세요?</a
                      >
                    </h6>
                  </div>
                </div> -->
                <!-- <div class="">
                  <div class="pull-left">
                    <p>
                      <a
                        class="link footer-link jipvio-login-color"
                        style="cursor: default;"
                        >지금 바로 가입하시면, 중개수수료 30% 할인쿠폰 제공</a
                      >
                    </p>
                  </div>
                </div> -->
              <!--</div>-->
              <!-- <div style="clear:both; ">
                <div class="pull-left">
                  <h6>
                    <a @click="getKakaoSingupForm()" class="link footer-link"
                      >카카오 로그인</a
                    >
                  </h6>
                </div>
                <div class="pull-right">
                  <h6>
                    <a class="link footer-link">네이버 로그인</a>
                  </h6>
                </div>
              </div> -->
              <div class="pull-right" style="width: 100px;height:50px">
                <!--
                <h6>
                  <a href="#pablo" class="link footer-link">Need Help?</a>
                </h6>
                -->
                <a id="kakao-login-btn"></a>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput } from "@/components";
import MainFooter from "@/layout/MainFooter";
import { Message, Checkbox } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";
import userApi from "@/service/user";
import kakaoApi from "@/service/kakao";

const {
  mapGetters: sessionMapGetters,
  mapActions: sessionMapActions
} = createNamespacedHelpers("loginSession");

export default {
  name: "login-page",
  bodyClass: "login-page",
  data() {
    return {
      loginInfo: {
        authProviderId: null,
        code: null,
        email: null,
        password: null,
        uid: null,
        checked: true
      }
    };
  },
  components: {
    Card,
    MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Message.name]: Message,
    [Checkbox.name]: Checkbox
  },
  computed: {
    ...sessionMapGetters({
      sessionCoCodeMap: "getCoCodeMap"
    })
  },
  mounted() {
    let self = this;
    const script = document.createElement("script");
    script.onload = () => {
      if (!Kakao.isInitialized()) {
        Kakao.init(process.env.VUE_APP_KKO_SDK_KEY);
      }
    };
    script.src = "https://developers.kakao.com/sdk/js/kakao.js";
    document.head.appendChild(script);
  },
  created() {
    this.sessionCoCodeMap.APV.forEach((ele, dex) => {
      if (this.$route.query.state !== undefined) {
        if (ele.code === this.$route.query.state) {
          this.loginInfo.authProviderId = ele.id;
        }
      } else {
        if (ele.code === "JVO") {
          this.loginInfo.authProviderId = ele.id;
        }
      }
    });

    if (this.$route.query.code !== undefined) {
      this.loginInfo.code = this.$route.query.code;
      this.oauthLogin();
    }
  },
  methods: {
    ...sessionMapActions(["setAuthToken"]),
    ...sessionMapActions(["setUserInfo"]),
    async getKakaoSingupForm() {
      const res = await kakaoApi.getOauthForm();
    },
    async oauthLogin() {
      const loginRes = await userApi.login(this.loginInfo);
      if (loginRes.status === 200) {
        Message.success("환영합니다.");
        this.setAuthToken(loginRes.payload.token);
        this.setUserInfo(loginRes.payload.user);
        this.$router.push("/");
      } else {
        Message.error(loginRes.message);
        this.setAuthToken(null);
        this.setUserInfo(null);
        this.$router.push("/");
      }
    },

    async login() {
      console.log("=====jipvio login try..");
      const loginRes = await userApi.login(this.loginInfo);
      if (loginRes.status === 200) {
        this.setAuthToken(loginRes.payload.token);
        this.setUserInfo(loginRes.payload.user);
        this.$router.push("/");
        // Common Code
      } else Message.error(loginRes.message);
    }
  }
};
</script>
<style>
/* div.jipvio-login {
  color: $light-black !important;
} */
</style>
